// @flow
import React from "react";
import { connect } from "react-redux";
import { Sentry } from "@nested/isomorphic-sentry";
import { type ContextRouter } from "react-router";
import { ServerError } from "../ServerError";
import { NotFound } from "../NotFound";
import { Loader } from "../../components/Loader/Loader";
import { PreviewMode } from "../../components/PreviewMode/PreviewMode";
import { Slice } from "./Slice";
import { MetaTags } from "./MetaTags";
import { fetchCustomPageSaga } from "./fetchData";

type OuterProps = ContextRouter<{ item: string }>;

type Props = {
  content: ?RemoteContent<PrismicCustomPage>,
};

type State = {
  hasError: boolean,
};

class CustomComponent extends React.Component<Props, State> {
  state = { hasError: false };

  componentDidCatch(e: Error, info: any) {
    Sentry.captureException(e, { info });
    this.setState({ hasError: true });
  }

  static fetchData = fetchCustomPageSaga;

  render() {
    const { hasError } = this.state;
    const { content } = this.props;

    if (hasError) {
      return <ServerError />;
    }

    if (content?.notFound) {
      return <NotFound />;
    }
    return (
      <Loader spinner={<div data-test="loading-div" />} content={content}>
        {(page) => (
          <div key={page.uid}>
            <MetaTags page={page} />
            <PreviewMode />
            {page.data.body.map((slice, index) => (
              <Slice key={index}>{slice}</Slice>
            ))}
          </div>
        )}
      </Loader>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  content: state.customPages[ownProps.match.params.item || "default"],
});

export const Custom = connect<Props, OuterProps, _, _, _, _>(mapStateToProps)(
  CustomComponent,
);

export const UniversalRender = Custom;
